import {
  AuthButtonContainer,
  AuthFields,
  AuthForm,
  AuthFormSubtitle,
  AuthFormTitle,
  AuthLogo,
  AuthWrapper
} from "@/layouts/AuthLayout/style";
import styled from "styled-components";

export const Wrapper = styled(AuthWrapper)``;

export const LogoContainer = styled(AuthLogo)``;

export const Title = styled(AuthFormTitle)``;

export const SubTitle = styled(AuthFormSubtitle)``;

export const ButtonContainer = styled(AuthButtonContainer)``;

export const Form = styled(AuthForm)``;

export const Fields = styled(AuthFields)``;
